import React from "react";
import "../../../css/Common/Components/ContactUs/TimeSlot.css";

/**
 * TimeSlots is a React component that renders a selectable time slot button.
 * 
 * Props:
 * @param {string} time - The time value to display in the button.
 * @param {boolean} isSelected - Indicates if the time slot is currently selected.
 * @param {boolean} disabled - If true, disables the button and applies a disabled style.
 * @param {function} onClick - Callback function invoked when the button is clicked, receiving the selected time as an argument.
 * 
 * Methods:
 * @method handleClick - Handles the button click event and calls the parent-provided onClick handler with the selected time.
 * 
 * Usage:
 * <TimeSlots
 *   time="10:00 AM"
 *   isSelected={true}
 *   disabled={false}
 *   onClick={handleTimeSelect}
 * />
 */
class TimeSlots extends React.Component {
  handleClick = () => {
    const { time, onClick } = this.props;

    // Call the parent-provided onClick handler with the selected time
    if (onClick) {
      onClick(time);
    }
  };

  render() {
    const { time, isSelected, disabled } = this.props;
    return (
      <>
        <button
          className={`TimeSlot ${disabled ? "disabled" : ""}`} // Add disabled class
          onClick={this.handleClick}
          disabled={disabled} // Apply native disabled attribute
        >
          <div className="Content">{time}</div>
        </button>
      </>
    );
  }
}

export default TimeSlots;
